import { get, getBackendBaseUrl } from "api/apiClient";
import { LoginSettings } from "./loginFlowTypes";

const baseUrl = getBackendBaseUrl();

export const getLoginData = async (): Promise<LoginSettings> => {
    return get<LoginSettings>(`${baseUrl}/auth/client-data`);
};
